import { render, staticRenderFns } from "./RelatorioComplianceTab.vue?vue&type=template&id=03c1b903"
import script from "./RelatorioComplianceTab.vue?vue&type=script&lang=js"
export * from "./RelatorioComplianceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports